module.exports = "/virtual-football-league/img/video/clubs/france/lyon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/france/lyon.png
// module id = 340
// module chunks = 4